import { combineReducers } from '@reduxjs/toolkit'
import exploreAll from './exploreAllSlice'

const reducer = combineReducers({
  exploreAll,
})

export default reducer
